<div id="wrapper">
  <top-bar></top-bar>
  <div class="content-page">
    <ngx-spinner type="ball-beat"></ngx-spinner>
    <div class="content">
      <!-- Start Content-->
      <div class="container-fluid px-0">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
